var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMetadatamanagerStandard = function SvgMetadatamanagerStandard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#fabc3c",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10L14 19h11zm0 3.84L21.43 17h-3.87zM25 21a4.5 4.5 0 104.5 4.5A4.494 4.494 0 0025 21zm0 7a2.5 2.5 0 112.5-2.5A2.5 2.5 0 0125 28zm-14.5 1.5h8v-8h-8zm2-6h4v4h-4z",
    fill: "#fabc3c"
  })));
};
export default SvgMetadatamanagerStandard;